import React, { useEffect, useRef } from 'react';
import { Checkbox as AllyCheckbox } from '@allygpo/ally-ux';

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Required: the box has no visible text of its own. */
  ariaLabel: string;
  disabled?: boolean;
  /** Some, not all, selected: shows a minus mark (Ally UX's check icon swapped), is announced as "mixed", and a click selects all. */
  indeterminate?: boolean;
  className?: string;
}

/** Ally UX Checkbox with a boolean onChange. Clicks don't reach clickable rows around it. */
const Checkbox: React.FC<CheckboxProps> = ({ checked, onChange, ariaLabel, disabled, indeterminate = false, className }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  // Set on the input directly: an aria-label prop would also land on Ally UX's wrapper div, labelling it twice.
  useEffect(() => {
    if (!inputRef.current) return;
    inputRef.current.indeterminate = indeterminate;
    inputRef.current.setAttribute('aria-label', ariaLabel);
  }, [indeterminate, ariaLabel]);
  return (
    <span className={`inline-flex${className ? ` ${className}` : ''}`} onClick={(event) => event.stopPropagation()}>
      <AllyCheckbox
        inputRef={inputRef}
        checked={checked || indeterminate}
        icon={indeterminate && !checked ? <i className="pi pi-minus text-2xs" aria-hidden="true" /> : undefined}
        disabled={disabled}
        onChange={(event) => onChange(indeterminate && !checked ? true : !!event.checked)}
      />
    </span>
  );
};

export default Checkbox;
